export * from './AssetDescriptor';
export type { AssetRegistry } from './AssetsRegistry';
